import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const ApplicationModule = {
  namespaced: true,
  strict: true,
  state: {
    application: null,
    currentStep: 0,
    haveEducation: false,
  },
  getters,
  actions,
  mutations
};

export default ApplicationModule;
